module.exports = __webpack_public_path__ + "d978df0af5.ttf";